import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import {TabViewCustom} from '../../../_models/tab-view-custom';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import { ListaItem } from '../../../_models/lista-item';
import { Plantilla } from '../../../_models/plantilla';

@Component( {
  selector: 'app-flujo-venta-autorizaciones',
  templateUrl: 'flujo-venta-autorizaciones.component.html'
} )

export class FlujoVentaAutorizacionesComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Input() lisEstados: SelectItem[] = [];
  @Input() lisAutorizaciones: ListaItem[] = [];
  @Input() lisPlantilla: Plantilla[] = [];
  @Input() lisFases: ListaItem[] = [];
  @Input() titulo: string;
  @Input() listasTiposProductosBancarios: SelectItem[] = [];
  tabSeleccionado = 'DATGEN';

  constructor() {
  }

  ngOnInit() {
  }

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = 'DATGEN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'REINT';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'PLANT';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
      default: {
        break;
      }
    }
  }

}
